<template>
  <div class="absolute top-0 h-full w-px bg-neutral-200 dark:bg-neutral-800" />
</template>
